import { useEffect, useState } from 'react';
import { Keyboard, KeyboardEvent, Platform } from 'react-native';

export const useKeyboardHeight = (enabled = true) => {
    const [keyboardHeight, setKeyboardHeight] = useState(0);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        const showEvent = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
        const hideEvent = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';

        const onShow = (e: KeyboardEvent) => {
            setKeyboardHeight(e.endCoordinates?.height ?? 0);
        };

        const onHide = () => {
            setKeyboardHeight(0);
        };

        const showSub = Keyboard.addListener(showEvent, onShow);
        const hideSub = Keyboard.addListener(hideEvent, onHide);

        return () => {
            showSub.remove();
            hideSub.remove();
        };
    }, [enabled]);

    return keyboardHeight;
};
